/* Dusty Gems Y2K — Product card color swatches with hover-swap image */
(function () {
  'use strict';

  function findPrimaryImg(card) {
    return (
      card.querySelector('img[data-dg-card-primary]') ||
      card.querySelector('.card__media img') ||
      card.querySelector('img')
    );
  }

  function applySwap(card, newSrc) {
    var img = findPrimaryImg(card);
    if (!img) return;
    if (!img.dataset.dgOrigSrc) {
      img.dataset.dgOrigSrc = img.getAttribute('src') || '';
      img.dataset.dgOrigSrcset = img.getAttribute('srcset') || '';
      img.dataset.dgOrigSizes = img.getAttribute('sizes') || '';
    }
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.setAttribute('src', newSrc);

    var pic = img.closest('picture');
    if (pic) {
      pic.querySelectorAll('source').forEach(function (s) {
        if (!s.dataset.dgOrig) s.dataset.dgOrig = s.getAttribute('srcset') || '';
        s.setAttribute('srcset', newSrc);
      });
    }

    var imgs = card.querySelectorAll('.media img');
    for (var i = 1; i < imgs.length; i++) imgs[i].style.opacity = '0';
    card.classList.add('dg-color-swap-active');
  }

  function restore(card) {
    var img = findPrimaryImg(card);
    if (!img) return;
    if (img.dataset.dgOrigSrc !== undefined) {
      img.setAttribute('src', img.dataset.dgOrigSrc);
      if (img.dataset.dgOrigSrcset) img.setAttribute('srcset', img.dataset.dgOrigSrcset);
      if (img.dataset.dgOrigSizes) img.setAttribute('sizes', img.dataset.dgOrigSizes);
    }
    var pic = img.closest('picture');
    if (pic) {
      pic.querySelectorAll('source').forEach(function (s) {
        if (s.dataset.dgOrig !== undefined) s.setAttribute('srcset', s.dataset.dgOrig);
      });
    }
    var imgs = card.querySelectorAll('.media img');
    for (var i = 1; i < imgs.length; i++) imgs[i].style.opacity = '';
    card.classList.remove('dg-color-swap-active');
  }

  function initCard(card) {
    var swatches = card.querySelectorAll('[data-dg-swatch]');
    if (!swatches.length) return;

    var seen = {};
    var uniqueCount = 0;
    swatches.forEach(function (sw) {
      var s = sw.getAttribute('data-dg-swatch-img');
      if (s && !seen[s]) { seen[s] = true; uniqueCount++; }
    });
    if (uniqueCount <= 1 && window.console) {
      var title = (card.querySelector('.card__heading') || {}).textContent || '';
      console.info(
        '[Dusty Gems] "' + title.trim() + '": alle Farb-Swatches zeigen dasselbe Bild. ' +
        'Bitte in Shopify pro Farb-Variante ein Bild zuweisen.'
      );
    }

    swatches.forEach(function (sw) {
      var src = sw.getAttribute('data-dg-swatch-img');
      if (!src) return;
      var preload = new Image();
      preload.src = src;

      sw.addEventListener('mouseenter', function () { applySwap(card, src); });
      sw.addEventListener('focus', function () { applySwap(card, src); });
      sw.addEventListener('touchstart', function (e) {
        e.preventDefault();
        applySwap(card, src);
      }, { passive: false });
    });

    var strip = card.querySelector('.dg-card-swatches');
    if (strip) {
      strip.addEventListener('mouseleave', function () { restore(card); });
    }
  }

  function start() {
    document.querySelectorAll('[data-dg-card]').forEach(initCard);
  }
  if (document.readyState !== 'loading') start();
  else document.addEventListener('DOMContentLoaded', start);
})();
